import React from 'react'
import '../assets/css/hero.css'
import decor3 from '../assets/images/Group-31.png'
import profil from '../assets/images/profimg.jpg'

const Hero = () => {
  return (
   <>
      <section className=" intro-page">
         <div className="decorations"> 
            <div className="decor-dot2">
               <img src={decor3} alt="" />
            </div>
            <div className="parcol"></div>
         </div>
         <div className="small-intro">
            <div className="intro-row">
               <div className="col-lg-7  col-md-6 col-sm-12 intro-left">
                  <div className="intro-name">
                     <h3
                        className="hello"
                        data-aos="fade-down"
                        data-aos-duration="1500"
                     >
                        DEVELOPPEUR FULLSTACK
                     </h3>
                     <h3
                        className="name"
                        data-aos="fade-down"
                        data-aos-duration="1600"
                     >
                        Salut! Je suis
                     </h3>
                     <h3
                        className="job  text-animate"
                        data-aos="fade-down"
                        data-aos-duration="1700"
                     >
                        Stanlay HOUNNOUVI
                     </h3>
                     <p
                        className="myinfo"
                        data-aos="fade-down"
                        data-aos-duration="1800"
                     >
                        Développeur d'applications passionné, je suis déterminé à créer des solutions innovantes et
                        intuitives pour répondre aux besoins des clients et améliorer leur expérience numérique. Mon
                        objectif est de continuer à développer mes compétences techniques et collaborer avec une
                        équipe dynamique pour créer des applications de qualité supérieure.
                     </p>
                  </div>
                  <div
                     className="intro-btns"
                     data-aos="fade-up"
                     data-aos-duration="1900"
                  >
                     <a
                        href="mailto:setonde.hounnouvi@epitech.eu"
                        className="contactMe"
                        target="_blank" rel="noreferrer"
                     >
                        <button className="contact-me">
                        Me joindre <i class="bx bx-send "></i>
                        </button>
                     </a>
                  </div>
                  <div
                     class="intro-contact"
                     data-aos="fade-up"
                     data-aos-duration="1800"
                  >
                     <span>Mes Réseaux:</span>
                     <ul>
                        <li>
                           {/* Github  */}
                           <a
                           href="https://github.com/Stilisky"
                           className="icon-link"
                           target="_blank"
                           rel="noopener noreferrer"
                           >
                              <i class="fa-brands fa-github"></i>
                           </a>
                           {/* LinkedIn */}
                           <a
                           href="https://www.linkedin.com/in/stanlay-hounnouvi-9a483a15b/"
                           className="icon-link"
                           target="_blank"
                           rel="noopener noreferrer"
                           >
                              <i class="fa-brands fa-linkedin"></i>
                           </a>
                           {/* Twitter */}
                           <a
                           href="https://twitter.com/STILISKY_"
                           className="icon-link"
                           target="_blank"
                           rel="noopener noreferrer"
                           >
                              <i class="fa-brands fa-x-twitter"></i>
                           </a>
                           {/* Whatsapp */}
                           <a
                           href='https://wa.me/22967660996'
                           className="icon-link"
                           target="_blank"
                           rel="noopener noreferrer"
                           >
                              <i class="fa-brands fa-whatsapp"></i>
                           </a>
                           {/* Facebook */}
                           <a
                           href="https://www.facebook.com/hounnouvi.stanley/"
                           className="icon-link"
                           target="_blank"
                           rel="noopener noreferrer"
                           >
                              <i class="fa-brands fa-facebook"></i>
                           </a>
                        </li>
                     </ul>
                  </div>
               </div>
               <div className="col-lg-5 col-md-6 col-sm-12 left-img "
               data-aos="fade-down-left"
               >
                  <div className="ff">
                     <img
                        className="intro-img"
                        src={profil}
                        alt=""
                     />
                  </div>
               </div>
            </div>
         </div>
      </section>
 </>
  )
}

export default Hero